import React from "react";
import "./App.css";
import "./styles/layout/layout.scss";
import AppLayout from "./components/Layout/AppLayout";
import LoginPage from "./pages/Login/LoginPage";
import AuthHandler from "./components/AuthHandler/AuthHandler";

function App() {
  const token = localStorage.getItem("api_token");
  const urlToken = new URLSearchParams(window.location.search).get("token");
  const isAuthenticated = !!(token || urlToken);

  return (
    <>
      <AuthHandler />
      {isAuthenticated ? <AppLayout /> : <LoginPage />}
    </>
  );
}

export default App;
